/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_WarrantyInputs */

const en_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warranty Included?`)
};

const es_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Garantía incluida?`)
};

const fr_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantie incluse ?`)
};

const de_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantie inklusive?`)
};

const ja_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保証の有無`)
};

const zh_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否含保修？`)
};

const ar_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل الضمان مشمول؟`)
};

const id_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termasuk Garansi?`)
};

const it_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garanzia Inclusa?`)
};

const ru_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гарантия включена?`)
};

const pt_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantia Incluída?`)
};

const ko_field_warranty = /** @type {(inputs: Field_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보증 포함 여부`)
};

/**
* | output |
* | --- |
* | "Warranty Included?" |
*
* @param {Field_WarrantyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_warranty = /** @type {((inputs?: Field_WarrantyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_WarrantyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_warranty(inputs)
	if (locale === "es") return es_field_warranty(inputs)
	if (locale === "fr") return fr_field_warranty(inputs)
	if (locale === "de") return de_field_warranty(inputs)
	if (locale === "ja") return ja_field_warranty(inputs)
	if (locale === "zh") return zh_field_warranty(inputs)
	if (locale === "ar") return ar_field_warranty(inputs)
	if (locale === "id") return id_field_warranty(inputs)
	if (locale === "it") return it_field_warranty(inputs)
	if (locale === "ru") return ru_field_warranty(inputs)
	if (locale === "pt") return pt_field_warranty(inputs)
	return ko_field_warranty(inputs)
});